export const SCENE_KEYS = ['Pad', 'Launch', 'Flight', 'Moon', 'Drill', 'Win'] as const;
export type SceneKey = (typeof SCENE_KEYS)[number];

const NEXT: Partial<Record<SceneKey, SceneKey>> = {
  Pad: 'Launch',
  Launch: 'Flight',
  Flight: 'Moon',
  Moon: 'Drill',
  Drill: 'Win',
};

export function sceneAfter(key: SceneKey): SceneKey | undefined {
  return NEXT[key];
}
